import './lib/RuntimeParams';
import '@/scss/globals.scss';
import '@/scss/vars.scss';

import('./index').catch(() => {});
